/** Die Meldung, die der Server geschickt hat — nicht „HTTP 422 on POST …".
 *
 *  `ApiError.message` ist die technische Zeile. Der Satz, der erklärt, WAS
 *  fehlt — „Dem Kunden fehlt eine E-Mail-Adresse · Der Vertrag hat keine
 *  Positionen" —, steht in `body.detail`. Ein Knopf, der stattdessen den
 *  HTTP-Status zeigt, zwingt zum Raten; genau das stand bis zum 18.09.2026 an
 *  zwölf Stellen dieser App.
 *
 *  Liegt hier und nicht bei den Hooks eines einzelnen Bereichs: die Meldung
 *  wird überall gebraucht, wo geschrieben wird.
 */
import { ApiError } from "@vimaana/ui";

export function fehlertext(fehler: unknown): string {
  if (fehler instanceof ApiError) {
    const detail = (fehler.body as { detail?: unknown } | null)?.detail;
    if (typeof detail === "string" && detail) return detail;
    if (Array.isArray(detail)) {
      // Pydantic meldet Validierungsfehler als Liste von Objekten.
      return detail.map(d => (d as { msg?: string }).msg || JSON.stringify(d)).join("\n");
    }
    return fehler.message;
  }
  return fehler instanceof Error ? fehler.message : String(fehler);
}
